const mapUserProfileType = (type) => {
  switch (type) {
    case '2':
      return 'teacher';
    case '3':
      return 'admin';
    default:
      return 'unknown';
  }
};

// Maps the portal-injected query params + locale to the package IdentityProps.
const buildIdentityProps = (params, locale) => ({
  locale,
  countryCode: params.countryCode || '',
  userProfileId: params.userProfileId || '',
  userProfileType: mapUserProfileType(params.userProfileType || ''),
  marketRegionId: params.marketRegionId || ''
});

export default buildIdentityProps;
